<script>
	import {
		ChartContext,
		DataTooltip,
		Html,
		KeyboardSelector,
		Pointer,
		Svg,
		TooltipState,
	} from '@vpap_svelte/charts';
	import { AppContext } from './Context.svelte';
	import { format, pack } from '@vpap_svelte/charts/d3';

	let ctx = AppContext.get();
	let dims = ChartContext.get();

	let packData = $derived.by(() => {
		if (!dims.chart.width || !dims.chart.height) return null;
		return pack().size([dims.chart.width, dims.chart.height]).padding(3)(ctx.packData);
	});

	let leaves = $derived.by(() => {
		if (packData === null) return null;
		return packData
			.leaves()
			.slice()
			.sort((a, b) => (a.y < b.y ? -1 : a.y > b.y ? 1 : a.x < b.y ? -1 : a.x > b.x ? 1 : 0));
	});

	let tooltip = new TooltipState();

	function clickoutside(node, tip) {
		/**
		 *
		 * @param e {MouseEvent & { target: Element }}
		 */
		let listener = (e) => {
			if (!node.contains(e.target)) {
				tip.hide();
			}
		};
		window.addEventListener('touchstart', listener);

		return window.removeEventListener('click', listener);
	}
</script>

<Html class="pointer-none">
	<KeyboardSelector
		type="flat"
		data={leaves}
		onSelectionChange={(record) => {
			if (record === undefined) {
				tooltip.hide();
				tooltip.data = null;
				ctx.tipChart = undefined;
			} else {
				tooltip.mouseover(record.selected);
				ctx.tipChart = 'circlepack';
			}
		}}
	></KeyboardSelector>
</Html>

<div use:clickoutside={tooltip}>
	<Html class="pointer-all">
		<Pointer
			data={leaves}
			xGet={(record) => record.x}
			yGet={(record) => record.y}
			maxOffset={40}
			onMovement={(pointer) => {
				tooltip.visible =
					pointer.isInside || pointer.current?.pointerType !== 'mouse' || ctx.isMobile;
			}}
			onSelectionChange={(record) => {
				if (record !== undefined) {
					tooltip.mouseover(record);
					ctx.tipChart = 'circlepack';
				} else {
					ctx.tipChart = undefined;
					tooltip.hide();
				}
			}}
		></Pointer>
	</Html>
</div>

<Svg class="pointer-none">
	<g class="packs">
		{#each leaves as leaf}
			{@const parent = leaf.parent.data.name}

			<g transform="translate({leaf.x + 1}, {leaf.y + 1})">
				<circle
					class:highlighted={tooltip.data === leaf}
					r={leaf.r}
					stroke="#42585c"
					fill={ctx.colorMapping.get(parent)}
				>
				</circle>
			</g>
		{/each}
	</g>
</Svg>

<Html class="pointer-none">
	{#if tooltip.data && ctx.tipChart === 'circlepack'}
		<DataTooltip
			id="g-tooltip"
			x={tooltip.data.x}
			y={tooltip.data.y}
			bind:visible={tooltip.visible}
			position={ctx.isMobile ? 'fixed-bottom' : 'absolute'}
			style={ctx.isMobile
				? { width: '100%', 'z-index': 2, 'pointer-events': 'all' }
				: { width: '325px', 'z-index': 2 }}
		>
			<div class="tip-head">
				<div class="tip-head-lg">{tooltip.data.data.name}</div>
				<div class="tip-head-sm">{tooltip.data.data.location}</div>
			</div>
			<div class="tip-content">
				<div class="circle-amt">
					Donated {format('$,.0f')(tooltip.data.value)}
				</div>
			</div>
		</DataTooltip>
	{/if}
</Html>

<style>
	.tip-head {
		font-size: 1rem;
		text-align: center;
		margin: 0.3em;
		border-bottom: 1px solid rgb(100, 100, 100);
	}

	.tip-head-sm {
		font-size: 0.85rem;
		text-transform: uppercase;
	}

	.tip-content {
		font-size: 0.9rem;
	}

	.circle-amt {
		text-align: center;
	}

	circle {
		fill-opacity: 0.8;
	}

	circle.highlighted {
		fill-opacity: 1;
	}
</style>
